export const LOADER_VISIBLE = 'LOADER_VISIBLE';
export const LOADER_INVISIBLE = 'LOADER_INVISIBLE';